export const FORM_URL_KEY = 'ekyc';
